import { CircularProgress, Stack, Typography } from "@mui/material";

export function Spinner({ label = "" }) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      padding={4}
      spacing={2}
      minHeight="100vh"
    >
      <CircularProgress />

      <Typography variant="overline">
        <strong>{label}</strong>
      </Typography>
    </Stack>
  );
}
